var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityHighest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#43f1c9d92a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.234 3.7-4.5 2.7c-.5.3-1.1.1-1.3-.4-.2-.5-.2-1.1.3-1.3l5-3c.3-.2.7-.2 1 0l5 3c.5.3.6.9.3 1.4-.3.5-.9.6-1.4.3l-4.4-2.7z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.734 10.7c-.5.3-1.1.1-1.3-.3-.2-.4-.2-1.1.3-1.4l5-3c.3-.2.7-.2 1 0l5 3c.5.3.6.9.3 1.4-.3.5-.9.6-1.4.3L8.233 8l-4.5 2.7z",
    fill: "#FF7452"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.734 15c-.5.3-1.1.2-1.3-.3-.2-.5-.2-1.1.3-1.4l5-3c.3-.2.7-.2 1 0l5 3c.5.3.6.9.3 1.4-.3.5-.9.6-1.4.3l-4.4-2.7-4.5 2.7z",
    fill: "#FF8F73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "43f1c9d92a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.25 .5)",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityHighest);
export default __webpack_public_path__ + "static/media/priority-highest.a0a8d3904eb46fce056c71e97da3fb48.svg";
export { ForwardRef as ReactComponent };